<script setup lang="ts">
import {computed, defineAsyncComponent} from "vue";
import {useNewsStore} from "~/stores/News";
import type {NewsCategoriesInterface, NewsInterface} from "~~/server/types/NewsInterface";

const NewsGridTemplate1 = defineAsyncComponent(() => import("~/components/news/NewsGridTemplate1.vue"));

const route = useRoute()
const { locale } = useI18n();
const { $api } = useNuxtApp();
const newsStore=useNewsStore();

const allNews=computed(()=>newsStore.list);
const allCategories=computed(()=>newsStore.categories);
const category_slug=computed(()=>route.params.category_slug);
const key_category_slug = computed(() => 'news_category:'+category_slug.value + ':' + locale.value)

interface getSectionNewsInterface {
  category:NewsCategoriesInterface|undefined,
  list:NewsInterface[]
}

const { data,error } = await useAsyncData<getSectionNewsInterface>(
    key_category_slug,
    () => allNews.value.length && allCategories.value.length
        ? Promise.resolve({
          category: newsStore.categories.find(
              i => i.url === category_slug.value
          ),
          list: newsStore.findProductsByCategory(String(category_slug.value))
        })
        : $api<getSectionNewsInterface>('blog/by/'+route.params.category_slug, {
          method: 'GET',
        }),
);
if (error.value) {showError(error.value)}
const category=computed<NewsCategoriesInterface|undefined>(()=>data.value?.category);
const list=computed<NewsInterface[]|undefined>(()=>data.value?.list);

onMounted(async () => {
  await Promise.all([
    newsStore.loadCategories(),
    newsStore.loadNews(),
  ])
})
usePageSeo({...category.value!,schemaType: 'website'});

</script>

<template>
  <section class="container-xxl product-page">
    <el-breadcrumb separator="/" class="pt-0 pt-lg-1 mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">{{$t('home_page')}}</el-breadcrumb-item>
      <el-breadcrumb-item >{{category?.name}}</el-breadcrumb-item>
    </el-breadcrumb>

    <h1 class="mb-5 section_title">{{category?.name}}</h1>
    <NewsGridTemplate1 v-if="list" :list="list" />
  </section>
</template>

